var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"backtotop"}},[(_vm.isVisible)?_c('button',{staticClass:"goTop",class:{ isVisible: _vm.isVisible },on:{"click":_vm.backToTop}},[_c('i',{staticClass:"fa fa-angle-up",attrs:{"aria-hidden":"true"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }